module.exports = __webpack_public_path__ + "static/media/fabric-admin-canvas.66d0a94b.svg";